var map = {
	"./Banner.vue": 2576,
	"./BigMinBanner.vue": 522,
	"./Footer.vue": 8440,
	"./HtmlContent.vue": 1392,
	"./HuaxianAttractCarrier.vue": 5298,
	"./HuaxianAttractProjectList .vue": 5823,
	"./HuaxianBanner.vue": 9811,
	"./HuaxianBannerLink.vue": 6557,
	"./HuaxianBreadcrumb.vue": 8346,
	"./HuaxianBrokenLine.vue": 3236,
	"./HuaxianCircular.vue": 3205,
	"./HuaxianColumnar.vue": 3697,
	"./HuaxianContact.vue": 5164,
	"./HuaxianCooperationList.vue": 7813,
	"./HuaxianCreditModel.vue": 3156,
	"./HuaxianCreditPolicy.vue": 4676,
	"./HuaxianFinanceProject.vue": 7273,
	"./HuaxianFinanceProjectDetail.vue": 4785,
	"./HuaxianFinanceProjectList.vue": 7718,
	"./HuaxianGeneralSituation.vue": 7525,
	"./HuaxianIndexNews.vue": 1005,
	"./HuaxianInfo.vue": 7874,
	"./HuaxianMenuDetail.vue": 1,
	"./HuaxianNewDetail.vue": 4707,
	"./HuaxianNewList.vue": 7061,
	"./HuaxianOtherFinance.vue": 3827,
	"./HuaxianOtherNews.vue": 3901,
	"./HuaxianProjectDetail.vue": 5289,
	"./HuaxianProjectGrid.vue": 3930,
	"./HuaxianPublicity.vue": 6064,
	"./HuaxianSpecial.vue": 9348,
	"./HuaxianVillageInfo.vue": 1752,
	"./HuaxianVillageInfoDetail.vue": 3364,
	"./HuaxiannewsRotation.vue": 7002,
	"./SanNong.vue": 8283,
	"./TuiJian.vue": 6377,
	"./VideoPlayer.vue": 5475,
	"./ZhongDian.vue": 5941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5951;